import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdresssService {

  constructor(private http: HttpClient) { }

  getGeolocation(lat: any, lng: any){
    return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyDFaXNvUSNlqQoqlNBgCgppWcSeYxb5kDM`)
  }
  doAddLocation(body: any){
    return this.http.post(`${environment.fireBase}alamat.json`, body)
  }

  getMapService(){
    return this.http.get(`${environment.fireBase}alamat.json`)
  }
  getMapById(id: any){
      return this.http.get(`${environment.fireBase}alamat.json?id=${id}`)
  }
  getStreetViewImage(latitude: number, longitude: number, heading: number, pitch: number, width: number, height: number, apiKey: string) {
    const streetViewUrl = `https://maps.googleapis.com/maps/api/streetview?size=${width}x${height}&location=${latitude},${longitude}&heading=${heading}&pitch=${pitch}&key=${apiKey}`;

    return this.http.get(streetViewUrl, { responseType: 'blob' });
  }
}
